import React from 'react';
import { createRoot } from 'react-dom/client';
import Section1Hero from '~go/web/src/js/external_components/landing/section_1_hero';
import Section7MainContent from '~go/web/src/js/external_components/landing/section_7_main_content';
import Section8MainContent from '~go/web/src/js/external_components/landing/section_8_main_content';

/**
 * JS logic for the landing page (landing.php)
 */
class Landing {
  constructor() {
    this.buildSection1Hero();
    this.buildSection7MainContent();
    this.buildSection8MainContent();
  }

  /**
   * Build section 1 hero content
   */
  buildSection1Hero() {
    const section1Hero = document.querySelector('.Section1Hero');
    if (!section1Hero) return;

    createRoot(section1Hero).render(<Section1Hero />);
  }

  /**
   * Build section 7 main content
   */
  buildSection7MainContent() {
    const section7MainContent = document.querySelector('.Section7MainContent');
    if (!section7MainContent) return;

    createRoot(section7MainContent).render(<Section7MainContent />);
  }

  /**
   * Build section 8 main content
   */
  buildSection8MainContent() {
    const section8MainContent = document.querySelector('.Section8MainContent');
    if (!section8MainContent) return;

    createRoot(section8MainContent).render(<Section8MainContent />);
  }
}

export default new Landing();
